xx/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">支付管理</el-breadcrumb-item>
      <el-breadcrumb-item>提现申请管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="跑腿人员：">
        <el-select size="small" v-model="formInline.userId" placeholder="请选择跑腿人员" clearable>
          <el-option label="全部" value=""/>
          <el-option v-for="item in courierList" :key="item.id" :value="item.id" :label="item.username"/>
        </el-select>
      </el-form-item>
      <el-form-item label="申请状态：">
        <el-select size="small" v-model="formInline.batchStatus" placeholder="请选择状态" clearable>
          <el-option label="全部" value=""/>
          <el-option label="转账已受理" value="ACCEPTED"/>
          <el-option label="转账处理中" value="PROCESSING"/>
          <el-option label="待收款用户确认" value="WAIT_USER_CONFIRM"/>
          <el-option label="转账结果尚未明确" value="TRANSFERING"/>
          <el-option label="转账成功" value="SUCCESS"/>
          <el-option label="转账失败" value="FAIL"/>
          <el-option label="转账撤销中" value="CANCELING"/>
          <el-option label="转账撤销完成" value="CANCELLED"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="orderTable" :data="dataList" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="outBatchNo" label="申请编号" width="160" show-overflow-tooltip/>
      <el-table-column align="center" prop="userName" label="跑腿人员" width="150" show-overflow-tooltip fixed/>
      <el-table-column align="center" prop="userPhone" label="跑腿电话" width="150" show-overflow-tooltip fixed/>
      <el-table-column align="center" prop="amount" label="提现金额" width="150" :formatter="amountFormat"/>
      <el-table-column align="center" prop="applyTime" label="申请时间" width="160" show-overflow-tooltip/>
      <el-table-column align="center" prop="batchName" label="说明" show-overflow-tooltip/>
      <el-table-column align="center" prop="batchStatusName" label="商家转账状态" />
      <el-table-column align="center" prop="reason" label="失败原因" width="150" show-overflow-tooltip/>
      <el-table-column align="center" label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <!--          <el-button size="mini" type="success" v-if="scope.row.status == 0" @click="pass(scope.row.id)">通过-->
          <!--          </el-button>-->
          <!--          <el-button size="mini" type="danger" v-if="scope.row.status == 0" @click="refuse(scope.row.id)">拒绝-->
          <!--          </el-button>-->
          <el-button size="mini" type="success"
                     v-if="scope.row.batchStatus != 'SUCCESS' && scope.row.batchStatus != 'FAIL' && scope.row.batchStatus != 'CANCELLED'"
                     @click="refresh(scope.row.id)">刷新
          </el-button>
          <el-button size="mini" type="danger"
                     v-if="scope.row.batchStatus == 'WAIT_USER_CONFIRM' || scope.row.batchStatus == 'TRANSFERING'"
                     @click="cancel(scope.row.id)">撤销
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增一个dialog用于输入备注 -->
    <el-dialog title="备注" :visible.sync="dialogVisible" width="30%" @close="resetDialog">
      <el-input v-model="remark" placeholder="请输入酒店订单号或取消原因"></el-input>
      <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirmChangeStatus">确认</el-button>
    </span>
    </el-dialog>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageParam" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import {queryExtractPage, auditExtract, cancelExtract, refreshExtract} from '../../api/commissionExtractMG'
import {courierList} from '../../api/userMG'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      user: {},
      editForm: {
        id: '',
        name: '',
        payType: 1,
        partner: '',
        subMchId: '',
        appid: '',
        notifyUrl: '',
        signType: '',
        partnerKey: '',
        sellerUserId: '',
        certPath: '',
        certPassword: '',
        rsaKey: '',
        token: localStorage.getItem('logintoken')
      },
      hotelSelect: [], //酒店下拉列表
      formInline: {
        page: 1,
        limit: 20,
        userId: "",
        batchStatus: ""
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      courierList: [], //跑腿人员
      dataList: [], //列表数据
      // 分页参数
      pageParam: {
        currentPage: 1,
        pageSize: 20,
        total: 20
      },
      dialogVisible: false, // 控制dialog的显示隐藏
      remark: '',//备注
      operationHint: '',
      status: '' //订单状态
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.queryCourierList();
    this.getdata(this.formInline);
    this.user = JSON.parse(localStorage.getItem('userdata'));
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //钱格式化显示
    moneyFormatter: function (row, column, cellValue) {
      return cellValue + " 元";
    },
    //查询跑腿人员
    queryCourierList: function () {
      courierList().then(res => {
        this.loading = false
        if (res.code != 0) {
          this.$message({type: 'info', message: res.msg})
        } else {
          this.courierList = res.data
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: res.message
        })
      })
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      queryExtractPage(parameter).then(res => {
        this.loading = false
        if (res.code != 0) {
          this.$message({type: 'info', message: res.msg})
        } else {
          this.dataList = res.data.list
          // 分页赋值
          this.pageParam.currentPage = res.data.page
          this.pageParam.pageSize = res.data.limit
          this.pageParam.total = res.data.total
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('订单加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(param) {
      this.formInline.page = param.currentPage
      this.formInline.limit = param.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //支付金额
    amountFormat(row) {
      return row.amount + " 元";
    },
    //状态：0-审核中 1-审核通过 2-已打回
    batchStatusFormat(row) {
      let batchStatusName = "";
      switch (row.batchStatus) {
        case "ACCEPTED":
          batchStatusName = "转账已受理";
          break;
        case "PROCESSING":
          batchStatusName = "转账处理中";
          break;
        case "WAIT_USER_CONFIRM":
          batchStatusName = "待收款用户确认";
          break;
        case "TRANSFERING":
          batchStatusName = "转账结果尚未明确";
          break;
        case "SUCCESS":
          batchStatusName = "转账成功";
          break;
        case "FAIL":
          batchStatusName = "转账失败";
          break;
        case "CANCELING":
          batchStatusName = "转账撤销中";
          break;
        case "CANCELLED":
          batchStatusName = "转账撤销完成";
          break;
      }
      return batchStatusName;
    },
    //通过
    pass(id) {
      this.$confirm('审核通过记录不可撤回，确认通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {"id": id, "status": 1}
        auditExtract(params).then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({type: 'info', message: res.message})
          } else {
            this.getdata(this.formInline)
            this.$message({type: 'success', message: '审核通过'})
            this.getdata(this.formInline)
          }
        })
      }).catch(() => {
      });
    },
    //拒绝
    refuse(id) {
      this.$prompt('拒绝原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: "请输入拒绝原因",
        inputPattern: /^.+$/,
        inputErrorMessage: '拒绝原因必填',
        type: 'warning'
      }).then(({value}) => {
        let params = {"id": id, "status": 2, "reason": value}
        auditExtract(params).then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({type: 'info', message: res.message})
          } else {
            this.getdata(this.formInline)
            this.$message({type: 'success', message: '审核拒绝'})
            this.getdata(this.formInline)
          }
        })
      }).catch(() => {
      });
    },
    //撤销
    cancel(id) {
      this.$confirm('撤销申请不可撤回，确认撤销?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        cancelExtract(id).then(res => {
          this.loading = false
          console.log(res)
          if (res.code != 0) {
            this.$message({type: 'info', message: res.msg})
          } else {
            this.getdata(this.formInline)
            this.$message({type: 'success', message: '撤销成功'})
            this.getdata(this.formInline)
          }
        })
      }).catch(() => {
      });
    },
    //刷新
    refresh(id) {
      refreshExtract(id).then(res => {
        this.loading = false
        console.log(res)
        if (res.code != 0) {
          this.$message({type: 'info', message: res.msg})
        } else {
          this.getdata(this.formInline)
          this.$message({type: 'success', message: '刷新成功'})
          this.getdata(this.formInline)
        }
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    changeOrderStatus: function (index, id, status, remark) {
      // this.loading = true
      let parm = {
        status: '',
        id: '',
        orderRemark: '',
        token: localStorage.getItem('logintoken')
      }
      parm.id = id
      parm.status = status
      if (status === '1') {
        this.operationHint = '确认恢复订单?';
      } else {
        parm.orderRemark = remark
      }
      let type = "success";
      if (4 == status) {
        type = 'warning'
      }
      this.$confirm(this.operationHint, '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: type
      }).then(() => {
        // 修改状态
        editOrderStatus(parm).then(res => {
          this.loading = false
          if (!res.success) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: '订单删除成功'
            })
            this.getdata(this.formInline)
          }
        })
      })
    },
    orderDelete: function (index, id) {
      this.$confirm("订单删除无法撤回，确认删除？", '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: "warning"
      }).then(() => {
        //订单删除
        orderDelete(id).then(res => {
          this.loading = false
          if (!res.success) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: '状态修改成功'
            })
            this.getdata(this.formInline)
          }
        })
      })
    },
    // 显示输入备注的dialog
    showRemarkDialog(index, row, status, operationHint) {
      this.dialogVisible = true;
      this.operationHint = operationHint;
      this.status = status;
      this.id = row.id;
      // 可以在这里根据需要设置row信息，以便后续操作
    },

    // 点击dialog中的确认按钮，执行状态变更
    confirmChangeStatus() {
      if (!this.remark.trim()) {
        this.$message.warning('请先输入备注信息！');
        return; // 如果备注为空，则不执行后续操作
      }
      this.changeOrderStatus(this.selectedIndex, this.id, this.status, this.remark);
      this.dialogVisible = false;
      this.resetDialog();
    },

    // 重置dialog内容
    resetDialog() {
      this.remark = ''; // 清空备注输入框
      // 可能还需要重置其他状态，比如selectedIndex, selectedRow等
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/views/order/commissionExtract.vue